import React from 'react';

const TailwindStatsCard = ({ 
    title, 
    value, 
    icon, 
    trend, 
    trendValue, 
    color = 'primary',
    description,
    onClick
}) => {
    const colorVariants = {
        primary: 'bg-primary text-primary bg-primary bg-opacity-10',
        indigo: 'bg-indigo-500 text-indigo-500 bg-indigo-50',
        green: 'bg-green-500 text-green-500 bg-green-50',
        yellow: 'bg-yellow-500 text-yellow-500 bg-yellow-50',
        red: 'bg-red-500 text-red-500 bg-red-50',
        purple: 'bg-purple-500 text-purple-500 bg-purple-50',
        blue: 'bg-blue-500 text-blue-500 bg-blue-50',
    };

    const [bgColor, textColor, lightBg] = colorVariants[color].split(' ');

    const getTrendIcon = () => {
        if (trend === 'up') {
            return (
                <div className="flex items-center text-green-600">
                    <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M3.293 9.707a1 1 0 010-1.414l6-6a1 1 0 011.414 0l6 6a1 1 0 01-1.414 1.414L10 4.414 4.707 9.707a1 1 0 01-1.414 0z" clipRule="evenodd" />
                    </svg>
                    <span className="text-sm font-medium">{trendValue}</span>
                </div>
            );
        } else if (trend === 'down') {
            return (
                <div className="flex items-center text-red-600">
                    <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 10.293a1 1 0 010 1.414l-6 6a1 1 0 01-1.414 0l-6-6a1 1 0 011.414-1.414L10 15.586l5.293-5.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    <span className="text-sm font-medium">{trendValue}</span>
                </div>
            );
        } else if (trend === 'neutral') {
            return (
                <div className="flex items-center text-gray-600">
                    <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clipRule="evenodd" />
                    </svg>
                    <span className="text-sm font-medium">{trendValue}</span>
                </div>
            );
        }
        return null;
    };

    return (
        <div 
            className={`bg-white border border-gray-200 rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow duration-200 ${onClick ? 'cursor-pointer hover:bg-gray-50' : ''}`}
            onClick={onClick}
        >
            <div className="flex items-center justify-between mb-4">
                <div className="flex items-center">
                    <div className={`p-3 rounded-lg ${color === 'primary' ? 'bg-primary bg-opacity-10' : lightBg}`}>
                        <div className={`w-6 h-6 ${color === 'primary' ? 'text-primary' : textColor}`}>
                            {icon}
                        </div>
                    </div>
                </div>
                {getTrendIcon()}
            </div>
            
            <div className="space-y-2">
                <h3 className="text-2xl font-bold text-gray-900">{value}</h3>
                <p className="text-sm font-medium text-gray-600">{title}</p>
                {description && (
                    <p className="text-xs text-gray-500">{description}</p>
                )}
            </div>
        </div>
    );
};

export default TailwindStatsCard; 